<template>
  <v-card>
    <v-app-bar class="headers text-center position-absolute" flat dense>
      <v-row>
        <v-col :class="classCenter" cols="6" md="8"
          ><v-combobox
            :items="model"
            @change="$emit('reset')"
            v-model="choseModelComputed"
            item-text="name_fa"
            label="انتخاب مدل هوش مصنوعی"
            outlined
            dense
            hide-details=""
        /></v-col>
        <v-col :class="classCenter" cols="4" md="4">
          <v-card-subtitle>{{ choseModelComputed?.name_fa }}</v-card-subtitle>
        </v-col>

        <v-col :class="classCenter" v-if="!mobile" cols="2"
          ><v-btn class="w-100 elevation-0" @click="drawerComputed = true">
            <v-icon>mdi-list-box-outline</v-icon>
          </v-btn></v-col
        >
      </v-row>
    </v-app-bar>
  </v-card>
</template>

<script>
import MenuAi from "../../../../components/chat/MenuAi.vue";
import ChatServices from "../../../../utilities/ChatServices";

export default {
  name: "appBar",

  props: { value: Boolean, choseModel: Object, model: Array },

  components: { MenuAi },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
    classCenter() {
      return "d-flex align-items-center justify-content-center";
    },
    drawerComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    choseModelComputed: {
      get() {
        return this.choseModel;
      },
      set(val) {
        this.$emit("update:choseModel", val);
      },
    },
  },

  data() {
    return {
      chatServices: null,

      loading: false,
    };
  },

  mounted() {
    this.chatServices = new ChatServices();
    this.getModels();
  },

  methods: {
    async getModels() {
      this.loading = true;
      try {
        const { data } = await this.chatServices.getModels();
        this.$emit("update:model", data.data);

        this.choseModelComputed = data.data[0];
      } catch {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.headers {
  height: 5rem !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
  align-content: center;
}
</style>
